export default "__VITE_ASSET__CGEfI3_Y__"